export default function retry(func, interval = 1000) {
    const intervalId = setInterval(func, interval);
    return () => {
        clearInterval(intervalId);
    };
}
